import React, { useEffect, useState, useCallback } from "react";
import ReactModal from 'react-modal'
import request, {cancelTokens} from "../../helpers/request";
import endpoints from "../../helpers/endpoints";
import syncRowHeights  from "../../helpers/syncRowHeights";
import axios from 'axios';

export default function VoaHistoryTable ({voaReference, translations, prefix}) {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [index, setIndex] = useState(0)
    const rows = [
        [translations['BA_Reference_Number'], 'BA_Reference_Number'],
        [translations['VOA_Description'], 'Primary_Description_Text'],
        [translations['Effective_Status'], 'Effective_Status'],
        [translations['Change_Reason'], 'Change_Reason'],
        [translations['Effective_Date'], 'Effective_Date'],
        [translations['Current_From_Date'], 'Current_From_Date'],
        [translations['SCAT_Code_And_Suffix'], 'SCAT_Code_And_Suffix'],
        [translations['Number_Or_Name'],  'Number_or_Name'],
        [translations['Street'], 'Street'],
        [translations['Sub_Street_level_1'], 'Sub_Street_Level_1'],
        [translations['Town'], 'Town'],
        [translations['Postal_District'], 'Postal_District'],
        [translations['County'], 'County'],
        [translations['Postcode'], 'Postcode'],
        'Full_Property_Identifier',
    ]

    const cycleIndex = useCallback((change = 0) => {
        if (change === 0) return
        if (index + change <= -1) return
        if (index + change >= data.length) return
        setIndex(index + change)
    }, [index, data])

    useEffect(() => {
        syncRowHeights()
    }, [index])

    const getData = () => {
        if (!voaReference) return
        setLoading(true)
        setData([])
        setIndex(0)
        request(true).get(endpoints[`${prefix}_VOA_HISTORY`], {
            doesCancel: true,
            params: {
                voaReference: voaReference
            }
        }).then(r => {
            setData(r.data)
            setLoading(false)
        }).catch(e => {
            setLoading(false)
            console.log(e)
        })
    }

    useEffect(() => {
        const url = endpoints[`${prefix}_VOA_HISTORY`]
        if (cancelTokens.has(url)) {
            const cancel = cancelTokens.get(url)
            cancel()
            cancelTokens.delete(url)
            setLoading(false)
        }
        getData()
    }, [voaReference])

    return (
        <div style={{ height: 'fit-content' }}>
            <table className="table borders squish smaller-text left sync scale-text" style={{ height: "100%", tableLayout: "fixed", wordBreak: "break-word" }}>
                <thead>
                    <tr style={{ height: '35px' }}>
                        <th colSpan={2}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {translations['VOA_History_Header']}
                                <div style={{ marginLeft: 'auto', display: 'flex', gap: 10 }}>
                                    {
                                        data?.length > 1 ? <>
                                        <span style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                            <span className='fas fa-angle-left' onClick={() => cycleIndex(-1)}></span>
                                            <span style={{minWidth: 60, textAlign: 'center'}}>{index+1}/{data.length}</span>
                                            <span className='fas fa-angle-right' onClick={() => cycleIndex(1)}></span>
                                        </span>
                                        </> : null
                                    }
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        rows.map((row, rowIndex) => {
                            if (Array.isArray(row)) {
                                return (
                                    <tr>
                                        <td>
                                            {row[0]}
                                        </td>
                                        <td style={{ textAlign: (loading && rowIndex === 0) ? 'center' : 'unset' }}>
                                            {
                                                rowIndex === 0 && loading ?
                                                    <i className="fa fa-spinner fa-spin"></i>
                                                :
                                                    voaReference && data[index]?.[row[1]]
                                            }
                                        </td>
                                    </tr>
                                )
                            } else {
                                return (
                                    <tr>
                                        <td style={{ minWidth: "60px", textAlign: 'center', borderBottom: "0px", color: "unset" }} colSpan={'2'}>
                                            {voaReference && data[index]?.[row]}
                                        </td>
                                    </tr>
                                )
                            }
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}